import styled, { css } from "styled-components";

interface ICheckbox {
  checked?: boolean;
}

const checkedStyles = css`
  background: var(--checkbox-checked-background) !important;
  color: var(--white) !important;
  border-color: var(--checkbox-checked-background) !important;
`;

const errorStyles = css`
  background: var(--input-error);
  color: var(--white);
  border-color: var(--input-error);
`;

const verifyingStyles = css`
  background: var(--input-verifying);
  color: var(--white);
  border-color: var(--input-verifying);
`;

const validateStyles = css`
  background: var(--input-success);
  color: var(--white);
  border-color: var(--input-success);
`;

export const Checkbox = styled.div<ICheckbox>`
  position: relative;

  width: 24px;
  height: 24px;

  display: flex;
  flex: 0 0 24px;
  justify-content: center;
  align-items: center;

  font-size: 32px;

  border: 1px solid var(--input-border);
  border-radius: 4px;

  cursor: pointer;

  transition: 0.2s;

  ${(props) => props.checked && checkedStyles}

  &.verifying {
    ${verifyingStyles}
  }

  &.validate {
    ${validateStyles}
  }

  &.error {
    ${errorStyles}
  }

  &.disabled {
    pointer-events: none;
    background-color: var(--input-disabled-background);
    border-color: var(--input-disabled-border);

    &:hover {
      border-color: var(--input-disabled-border);
    }
  }

  input {
    width: 100%;
    height: 100%;

    position: absolute;
  }

  path {
    stroke-width: 3;
  }
`;

export const Container = styled.div``;

export const Wrapper = styled.div`
  display: flex;

  label {
    display: flex;
    align-items: center;

    margin-left: 0.5rem;
  }
`;
